var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-sticker-list-component" }, [
    _c(
      "div",
      { staticClass: "room-sticker-list" },
      _vm._l(_vm.stickerList, function (sticker, i) {
        return _c(
          "button",
          {
            key: i,
            staticClass: "room-sticker-button",
            class: sticker,
            on: {
              click: function ($event) {
                return _vm.onClickSticker(sticker)
              },
            },
          },
          [i > 9 && i < 20 ? [_vm._v(_vm._s(i === 19 ? 0 : i - 9))] : _vm._e()],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }